import Vue from 'vue';
import SvgSprite from 'vue-svg-sprite';

Vue.use(SvgSprite, {
  url: '/static/sprite.svg',
  class: 'svg-sprite',
});



// WEBPACK FOOTER //
// ./src/plugins/svg-sprite.js